export function AuroraBackground({ className = "" }: { className?: string }) {
  return (
    <div
      aria-hidden
      className={`pointer-events-none absolute inset-0 overflow-hidden ${className}`}
    >
      {/* Aurora gradients */}
      <div
        className="absolute -top-32 -left-24 size-[42rem] rounded-full blur-3xl opacity-60 animate-pulse-glow"
        style={{ background: "radial-gradient(circle, rgba(217,70,239,0.45), transparent 60%)" }}
      />
      <div
        className="absolute -top-20 right-0 size-[36rem] rounded-full blur-3xl opacity-50 animate-pulse-glow"
        style={{
          background: "radial-gradient(circle, rgba(123,63,242,0.55), transparent 60%)",
          animationDelay: "2s",
        }}
      />
      <div
        className="absolute bottom-[-10rem] left-1/3 size-[40rem] rounded-full blur-3xl opacity-40 animate-pulse-glow"
        style={{
          background: "radial-gradient(circle, rgba(244,114,208,0.40), transparent 60%)",
          animationDelay: "4s",
        }}
      />
      {/* Subtle wave */}
      <svg
        className="absolute inset-x-0 bottom-0 w-full opacity-[0.08]"
        viewBox="0 0 1200 200"
        preserveAspectRatio="none"
      >
        <defs>
          <linearGradient id="wave" x1="0" x2="1">
            <stop offset="0%" stopColor="#F472D0" />
            <stop offset="50%" stopColor="#D946EF" />
            <stop offset="100%" stopColor="#7B3FF2" />
          </linearGradient>
        </defs>
        <path
          d="M0,120 C200,40 400,180 600,120 C800,60 1000,180 1200,100 L1200,200 L0,200 Z"
          fill="url(#wave)"
        />
      </svg>
    </div>
  );
}
